import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import ParameterFormComponent from './parameters-form.component';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function ParametersActionComponent(props) {
    const query = useQuery();
    const history = useHistory();

    return (
        <div>
            {(() => {
                switch (query.get("mode")) {
                    case 'edit':
                        return (
                            <ParameterFormComponent />
                        );
                    default:
                        history.push(`/masters/parameters/${props.match.params.id}?mode=edit`);
                }
            })()}
        </div>
    );
}